module.exports = __webpack_public_path__ + "img/spire-logo.7eae6ff2.jpg";